<ng-container *ngIf="warranty$ | async as warranty">
  <div class="px-2" *vsLet="audits$ | async as audits">
    <div class="flex justify-between items-center mb-4">
      <div class="flex items-center gap-2">
        <h3 class="text-sm font-medium text-gray-700">Audit Trail</h3>
        <vs-badge theme="default">
          {{ audits?.meta?.totalItems || 0 }} Change{{ (audits?.meta?.totalItems || 0) !== 1 ? 's' : '' }}
        </vs-badge>
      </div>
      <p *ngIf="audits?.items?.[0] as latest" class="text-xs text-gray-400">
        Last updated: {{ latest.changedAt | date:'dd/MM/yy hh:mm a' }}
        <span class="text-primary-500 cursor-pointer ml-1" (click)="refresh()">Refresh</span>
      </p>
    </div>

    <ng-container *ngIf="loaded$ | async; else isLoading">
      <ng-container *ngIf="audits?.items as auditItems">
        <ng-container *ngIf="auditItems.length > 0; else noAudits">
          <div class="flex flex-col gap-4 mb-4">
            <ng-container *ngFor="let audit of auditItems; index as index">
              <div class="flex gap-3 items-start">
                <div class="w-14 flex flex-col items-center relative mt-1">
                  <ng-container *ngIf="audit._user as user; else noPhoto">
                    <ng-container *ngIf="user.photoURL; else noPhoto">
                      <div class="shadow rounded-full">
                        <div
                          class="flex justify-center min-w-10 max-w-10 w-10 min-h-10 max-h-10 h-10 rounded-full border-base-white border bg-base-white"
                        >
                          <vs-user-avatar class="w-10 h-10" [config]="{ photoUrl: user.photoURL }"></vs-user-avatar>
                        </div>
                      </div>
                    </ng-container>
                  </ng-container>

                  <ng-template #noPhoto>
                    <div class="shadow rounded-full">
                      <div
                        class="flex justify-center min-w-10 max-w-10 w-10 min-h-10 max-h-10 h-10 rounded-full border-base-white border bg-primary-50 shadow"
                      >
                        <p class="font-medium text-primary-600 self-center">{{ getInitials(audit._user || null) }}</p>
                      </div>
                    </div>
                  </ng-template>

                  <div *ngIf="index < auditItems.length - 1" class="w-px h-full border-r mt-1"></div>
                </div>

                <div
                  class="flex-1 bg-white rounded-lg border-l-4 border-primary-500 px-4 py-2 shadow-sm mb-2 overflow-hidden"
                >
                  <div class="flex justify-between mb-1">
                    <div class="flex flex-wrap gap-1 text-sm">
                      <span class="font-semibold"> {{ audit._user?.displayName || 'System' }} </span>

                      <span>changed</span>

                      <span class="font-semibold"> {{ audit.fieldName | titlecase }} </span>
                    </div>

                    <div class="flex gap-1 text-xs text-gray-500 whitespace-nowrap">
                      <vs-icon name="clock"></vs-icon>
                      <span>{{ audit.changedAt | date:'dd/MM/yy hh:mm a' }}</span>
                    </div>
                  </div>

                  <p class="text-sm mt-1">
                    From
                    <span class="text-red-600 font-medium"> "{{ audit.beforeValue || '—' }}" </span>
                    to
                    <span class="text-green-600 font-medium"> "{{ audit.afterValue || '—' }}" </span>.
                  </p>

                  <p *ngIf="audit.reason" class="text-xs text-gray-600 mt-2 italic">
                    <vs-icon name="message-text-square-01" size="12"></vs-icon>
                    {{ audit.reason }}
                  </p>
                </div>
              </div>
            </ng-container>
          </div>

          <vs-pagination [config]="paginationConfig$ | async" (pagination)="onPageChange($event)"></vs-pagination>
        </ng-container>

        <ng-template #noAudits>
          <vs-icon-empty-state
            name="clock"
            [config]="{
              title: 'No changes have been recorded yet.',
              subtitle: 'Once this warranty is updated, those changes will appear here.'
            }"
          ></vs-icon-empty-state>
        </ng-template>
      </ng-container>
    </ng-container>

    <ng-template #isLoading>
      <div class="flex items-center justify-center min-h-[275px]">
        <vs-icon name="loading-01" class="text-primary-500 animate-spin" size="35"></vs-icon>
      </div>
    </ng-template>
  </div>
</ng-container>
